<!-- =========================================================================================
    File Name: CompanyListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card title="Related Products">
    <vs-progress v-if="loading" indeterminate color="primary"></vs-progress>

    <div class="vx-row no-gutter">
      <div class="vx-col w-full">
        <label for="related-products">{{ `${selectedProducts.length} Products` }}</label>
        <v-select id="related-products" multiple label="_name" :value="selectedProducts" :reduce="product => product.product_id" @input="productSelectionChanged" :options="unSelectedProducts" />
      </div>
    </div>

  </vx-card>

</template>

<script>
  import types from '@/models';
  import jsonHtml from '@/misc/jsonHtmlPrinter';
  import helpers from '@/models/helpers';
  import api from '@/http/api';

  export default {
    components: {
    },
    data() {
      return {
        loadingCount: 0,
        types: types,
        jsonHtml: jsonHtml,
        productHelpers: helpers.product,
        selectedProductIds: [],
        allProducts: [],
        relatedProducts: [],
        products: [],
      }
    },
    props: {
      product: {
        type: types.Product,
        required: true,
      },
    },
    watch: {
      async product(oldVal, newVal) {
        if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return;
        await this.fetchAll();
        await this.setUpWorkingData();
      },
    },
    computed: {
      productId() {
        return this.$route.query.id || null;
      },
      selectedProducts() {
        return this.allProducts.filter((product) => {
          return this.selectedProductIds.indexOf(product.product_id) !== -1;
        });
      },
      unSelectedProducts() {
        return this.allProducts.filter((product) => {
          return this.selectedProductIds.indexOf(product.product_id) === -1;
        });
      },
      loading() {
        return this.loadingCount > 0;
      }
    },
    methods: {
      async fetchAll() {
        this.loadingCount++;
        await this.fetchProducts();
        await this.fetchRelatedProducts();
        this.loadingCount--;
      },
      async fetchRelatedProducts() {
        this.relatedProducts = await api.fetchRelatedProducts(this.productId);
      },
      async fetchProducts() {
        let products = await api.fetchProductsForCompany(this.product.company_id);
        products.forEach((it) => {
          it._name = `${it.product_id} - ${this.productHelpers.getPreferredName(it)}`;
        });

        this.products = products;
      },
      async productSelectionChanged(newSelectedProducts) {
        if (newSelectedProducts.length === this.selectedProductIds.length) return;
        const productAdded = newSelectedProducts.length > this.selectedProductIds.length;

        let success = false;
        if (productAdded) {
          let addedProductId = newSelectedProducts.filter(x => !this.selectedProductIds.includes(x))[0];
          success = await api.addRelatedProduct(this.product, addedProductId);
        } else {
          let removedProductId = this.selectedProductIds.filter(x => !newSelectedProducts.includes(x))[0];
          success = await api.removeRelatedProduct(this.product, removedProductId);
        }

        this.showNotification(success, productAdded ? `Product relation${success ? '' : ' NOT'} added.` : `Product relation${success ? '' : ' NOT'} removed.`);

        this.selectedProductIds = newSelectedProducts;

      },
      setUpWorkingData() {
        this.selectedProductIds = this.relatedProducts.map((product) => product.product_id);
        // filter out the current product (so we don't relate it to itself)
        this.allProducts = JSON.parse(JSON.stringify(this.products)).filter((it) => it.product_id !== this.product.product_id );
      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
    }
  }
</script>

<style lang="css" scoped>
  .fill-row-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
</style>
